import React from 'react';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';

interface IProps {
  clinicalStore?: any;
}

@inject('clinicalStore')
@observer
class EmptyMessage extends React.Component<IProps> {
  render() {
    if (!this.show) return null;

    return <h5 className="empty-message">This case has no attachments</h5>;
  }

  @computed
  get show() {
    let { attachments, status } = this.props.clinicalStore.prontoStore;
    return status === 'fullfilled' && attachments.length === 0;
  }
}

export default EmptyMessage;
